/**
 * Disponibilidad efectiva para envío NP por líneas de guía (guide_detail_id).
 */

export function committedKgByGuideDetailIdFromItems(items) {
	const out = {};
	for (const item of items || []) {
		const mv = item?._module_vars;
		if (!mv?._is_warehouse_guide_lines_send) continue;
		const ids = mv.guide_detail_ids || [];
		const kgs = mv.individual_kilograms || [];
		ids.forEach((id, idx) => {
			const key = String(id);
			const kg = Number(kgs[idx] ?? item?.QtyItem ?? 0);
			out[key] = (out[key] || 0) + (Number.isFinite(kg) ? kg : 0);
		});
	}
	return out;
}

export function withoutWarehouseGuideLinesSendItems(items) {
	return (items || []).filter(
		row => !row?._module_vars?._is_warehouse_guide_lines_send,
	);
}

export function withoutWarehouseGuideLinesSendItemsRenumbered(items) {
	return withoutWarehouseGuideLinesSendItems(items).map((it, i) => ({
		...it,
		NroLinDet: i + 1,
	}));
}

export function guideLineSendResidueKey(residueId) {
	return String(residueId);
}
